export class VariantFilter<T extends string | string[] = string> {
  domain!: string; // Same as Validity slug
  entry!: T;

  constructor(domain: string, entry: T) {
    this.domain = domain;
    this.entry = entry;
  }
}
